import { render, staticRenderFns } from "./CargoClaimPosted.vue?vue&type=template&id=502cc47d&"
import script from "./CargoClaimPosted.vue?vue&type=script&lang=js&"
export * from "./CargoClaimPosted.vue?vue&type=script&lang=js&"
import style0 from "./CargoClaimPosted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoClaimPosted.vue"
export default component.exports